import { useNavigate } from "react-router-dom";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Typography,
  } from "@mui/material";

import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

const ConfigTable = ({configList}) =>{
    const navigate = useNavigate();
    const nav = (id) => {
        navigate(`/BackOffice/${id}/Products`);
      };
    return(
    <TableContainer sx={{mt:4, ml: 1}} component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h6">Id</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6">Name</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6">Encrypyted</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6">Config Type </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6">Config Value </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6">Time Updated </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6">Action</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {configList.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.encrypted_value}</TableCell>
                <TableCell>{row.config_type}</TableCell>
                <TableCell>{row.config_value}</TableCell>
                <TableCell>{row.time_updated}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => nav(row.company_id)}
                  >
                    <KeyboardDoubleArrowRightIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>);

};

export default ConfigTable;